import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../feature/drivers/driverSlice";

const DriverModals = () => {
  const dispatch = useDispatch();
  const { isViewModalOpen, isDeleteModalOpen, viewSingleDriver } = useSelector(
    (state) => state.drivers
  );

  const ViewDriverModal = () => {
    return (
      <Dialog open={isViewModalOpen} onClose={() => dispatch(closeModal())}>
        <DialogTitle> {viewSingleDriver.id} </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Name: {viewSingleDriver.first_name}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            Email: {viewSingleDriver.email}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color='secondary'
            onClick={() => dispatch(closeModal())}
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const DeleteConfirmationModal = () => {
    return (
      <Dialog open={isDeleteModalOpen}>
        <DialogTitle>Delete {viewSingleDriver.user} </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete this order?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color='error'>Delete</Button>
          <Button
            color='secondary'
            onClick={() => dispatch(closeModal())}
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      <ViewDriverModal />
      <DeleteConfirmationModal />
    </>
  );
};

export default DriverModals;
